// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"kV-z","smallCardRow":"lV-z","largeCardRow":"mV-z","productSearchRow":"nV-z","curatedRow":"oV-z"};